module.exports = __webpack_public_path__ + "img/Recurso 8@300x.65f1e6a5.webp";